"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ActionTypes = require("FileManagerCore/actions/ActionTypes");

var _Actions = require("FileManagerLib/actions/Actions");

var _default = function _default(_ref) {
  var dispatch = _ref.dispatch;
  return function (next) {
    return function (action) {
      var result = next(action);

      switch (result.type) {
        case _ActionTypes.UPLOAD_EDITED_IMAGE_SUCCEEDED:
          dispatch((0, _Actions.selectFile)(result.file));
          break;

        default:
          break;
      }

      return result;
    };
  };
};

exports.default = _default;
module.exports = exports.default;